/**
 * @file One label and value line of a `ResponsiveTable` card: the label in secondary text, then the
 * value, wrapping beneath it when the card is too narrow. Consumers: `ResponsiveTableCard` for each body
 * column, and callers building a `cardSummary` (the ledger totals cards), so a totals card reads like a
 * row card. An empty label draws no label; a string or number value is wrapped in `Text`, any other node
 * renders as given.
 */
import type { ReactNode } from 'react';
import { Typography } from 'antd';

import FlexBox from '../FlexBox';
import type { ResponsiveTableCardLineProps } from './ResponsiveTable.types';

const { Text } = Typography;

const ResponsiveTableCardLine = ({ label, value }: ResponsiveTableCardLineProps): ReactNode => (
  <FlexBox justifyStart alignStart wrap gap={5}>
    {label !== undefined && label !== null && label !== '' && <Text type="secondary">{label}</Text>}
    {typeof value === 'string' || typeof value === 'number' ? <Text>{value}</Text> : value}
  </FlexBox>
);

export default ResponsiveTableCardLine;
